// extracted by mini-css-extract-plugin
export default {"cmsContent":"TermsAndCondition_cmsContent__-EMw5"};